"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Select = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactSelect = _interopRequireDefault(require("react-select"));
var _async = _interopRequireDefault(require("react-select/async"));
var _creatable = _interopRequireDefault(require("react-select/creatable"));
var _asyncCreatable = _interopRequireDefault(require("react-select/async-creatable"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = require("styled-components");
var _lodash = _interopRequireDefault(require("lodash.noop"));
var _oxygenConfig = require("@8x8/oxygen-config");
var _oxygenLabel = _interopRequireDefault(require("@8x8/oxygen-label"));
var _customStyles = _interopRequireDefault(require("../constants/customStyles"));
var _ClearIndicator = _interopRequireDefault(require("./ClearIndicator"));
var _DropdownIndicator = _interopRequireDefault(require("./DropdownIndicator"));
var _SingleValue = _interopRequireDefault(require("./SingleValue"));
var _MultiValue = _interopRequireDefault(require("./MultiValue"));
var _Option = _interopRequireDefault(require("./Option"));
var _ValueContainer = _interopRequireDefault(require("./ValueContainer"));
var Styled = _interopRequireWildcard(require("../styled"));
var _excluded = ["action", "actionLabel", "components", "forwardedRef", "infoBoxText", "isAsync", "isCreatable", "isRequired", "labelValue", "onBlur", "onChange", "theme"]; // @ts-check
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var Select = function Select(_ref) {
  var action = _ref.action,
    actionLabel = _ref.actionLabel,
    components = _ref.components,
    forwardedRef = _ref.forwardedRef,
    infoBoxText = _ref.infoBoxText,
    isAsync = _ref.isAsync,
    isCreatable = _ref.isCreatable,
    isRequired = _ref.isRequired,
    labelValue = _ref.labelValue,
    onBlur = _ref.onBlur,
    onChange = _ref.onChange,
    theme = _ref.theme,
    rest = _objectWithoutProperties(_ref, _excluded);
  var selectRef = (0, _react.useRef)(null);
  (0, _react.useImperativeHandle)(forwardedRef, function () {
    return _objectSpread(_objectSpread({}, selectRef.current), {}, {
      focus: function focus() {
        if (selectRef.current) {
          selectRef.current.select.focus();
        }
      }
    });
  });
  var getTheme = function getTheme(defaultTheme) {
    var menuGutter = theme.menuGutter,
      baseUnit = theme.baseUnit;
    return _objectSpread(_objectSpread(_objectSpread({}, defaultTheme), theme), {}, {
      spacing: _objectSpread(_objectSpread({}, defaultTheme.spacing), {}, {
        baseUnit: baseUnit,
        menuGutter: menuGutter
      })
    });
  };
  var testId = rest.testId,
    isMulti = rest.isMulti,
    isDisabled = rest.isDisabled,
    hideSelectedOptions = rest.hideSelectedOptions;
  var customStyles = (0, _customStyles["default"])(theme);
  var labelFontWeight = theme.labelFontWeight;
  var labelTheme = {
    fontWeight: labelFontWeight
  };
  var labelProps = {
    action: action,
    actionLabel: actionLabel,
    isRequired: isRequired,
    infoBoxText: infoBoxText,
    value: labelValue
  };
  var SelectComponent = (0, _react.useMemo)(function () {
    if (isAsync && isCreatable) {
      return _asyncCreatable["default"];
    }
    if (isAsync) {
      return _async["default"];
    }
    if (isCreatable) {
      return _creatable["default"];
    }
    return _reactSelect["default"];
  }, [isAsync, isCreatable]);
  return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, labelValue && /*#__PURE__*/_react["default"].createElement(_oxygenLabel["default"], _extends({
    testId: "".concat(testId, "_LABEL"),
    theme: labelTheme,
    showTooltipOnOverflow: true,
    isDisabled: isDisabled
  }, labelProps)), /*#__PURE__*/_react["default"].createElement(Styled.SelectContainer, _extends({
    hasLabel: labelValue
  }, (0, _oxygenConfig.getTestAttributes)("".concat(testId, "_CONTAINER"))), /*#__PURE__*/_react["default"].createElement(SelectComponent, _extends({
    "aria-label": labelValue || rest.placeholder
  }, rest, {
    testId: testId,
    components: _objectSpread({
      ClearIndicator: _ClearIndicator["default"],
      DropdownIndicator: _DropdownIndicator["default"],
      MultiValue: _MultiValue["default"],
      Option: _Option["default"],
      ValueContainer: _ValueContainer["default"],
      SingleValue: _SingleValue["default"]
    }, components),
    theme: getTheme,
    styles: customStyles,
    onChange: onChange,
    hideSelectedOptions: hideSelectedOptions,
    isMulti: isMulti,
    onBlur: onBlur,
    closeMenuOnSelect: !isMulti,
    ref: selectRef
  })))));
};
exports.Select = Select;
Select.propTypes = {
  action: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].string]),
  actionLabel: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  components: _propTypes["default"].object,
  forwardedRef: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].func]),
  hasCheckbox: _propTypes["default"].bool,
  hasError: _propTypes["default"].bool,
  hasIcons: _propTypes["default"].bool,
  hasShortMultiDisplay: _propTypes["default"].bool,
  hideSelectedOptions: _propTypes["default"].bool,
  iconLeft: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].node, _propTypes["default"].elementType]),
  infoBoxText: _propTypes["default"].string,
  isAsync: _propTypes["default"].bool,
  isClearable: _propTypes["default"].bool,
  isCreatable: _propTypes["default"].bool,
  isDisabled: _propTypes["default"].bool,
  isMulti: _propTypes["default"].bool,
  isRequired: _propTypes["default"].bool,
  labelValue: _propTypes["default"].string,
  multipleSelectMaxRows: _propTypes["default"].number,
  noOptionsMessage: _propTypes["default"].func,
  onBlur: _propTypes["default"].func,
  onChange: _propTypes["default"].func,
  placeholder: _propTypes["default"].node,
  size: _propTypes["default"].oneOf(['default', 'large', 'small']),
  testId: _propTypes["default"].string,
  theme: _propTypes["default"].object.isRequired
};
Select.defaultProps = {
  action: '',
  actionLabel: '',
  components: {},
  forwardedRef: null,
  hasCheckbox: false,
  hasError: false,
  hasIcons: false,
  hasShortMultiDisplay: false,
  hideSelectedOptions: false,
  iconLeft: null,
  infoBoxText: undefined,
  isAsync: false,
  isClearable: true,
  isCreatable: false,
  isDisabled: false,
  isMulti: false,
  isRequired: false,
  labelValue: undefined,
  multipleSelectMaxRows: 1,
  noOptionsMessage: function noOptionsMessage() {
    return 'No options...';
  },
  onBlur: _lodash["default"],
  onChange: _lodash["default"],
  placeholder: 'Select...',
  size: 'default',
  testId: 'SELECT'
};
var _default = (0, _oxygenConfig.withTheme)(Select, 'select');
exports["default"] = _default;